import { erc20Abi } from 'viem';
import { useReadContract, useReadContracts } from 'wagmi';
import { useMemo } from 'react';
import { Erc20AllowanceParams } from '@/types';

export const useERC20Allowance = (erc20AllowanceParams: Erc20AllowanceParams) => {
  const { owner, spender, tokenAddress } = erc20AllowanceParams;

  const {
    data: allowance,
    isLoading,
    isError,
    error,
  } = useReadContract({
    address: tokenAddress,
    abi: erc20Abi,
    functionName: 'allowance',
    args: [owner, spender],
  });

  return {
    allowance,
    isLoading,
    isError,
    error,
  };
};

// batch read
export const useERC20Allowances = (erc20AllowanceList: Erc20AllowanceParams[]) => {
  const contracts = useMemo(() => {
    return erc20AllowanceList.map((erc20AllowanceParams) => {
      const { owner, spender, tokenAddress } = erc20AllowanceParams;
      return {
        address: tokenAddress,
        abi: erc20Abi,
        functionName: 'allowance',
        args: [owner, spender],
      };
    });
  }, [erc20AllowanceList]);

  const {
    data: allowanceList,
    isLoading,
    isError,
    error,
    refetch,
  } = useReadContracts({
    contracts,
  });

  return {
    allowanceList,
    isLoading,
    isError,
    error,
    refetch,
  };
};
